var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aircraft-container"},[_c('ReturnButton'),_c('AircraftBanner',{attrs:{"image":_vm.aircraft.file}}),_c('AircraftText',{attrs:{"date":_vm.aircraft.created_at}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }